import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import ExternalLayout from "examples/LayoutContainers/ExternalLayout";
import { useMaterialUIController } from "context";
import { useTranslation } from "react-i18next";
import 'assets/css/common.css';

function TermsAndConditions() {
  const { t } = useTranslation();
  const [controller] = useMaterialUIController();
  const { MyContext } = controller;

  return (
    <ExternalLayout>
      <Card className="termsAndConditions">
        <MDBox sx={{ my: 4 }} >
          <MDTypography variant="h4" component="h1" gutterBottom>
            {t('termsAndConditions')}
          </MDTypography>
          <MDTypography variant="body1" gutterBottom>
            {MyContext.termsAndConditions}
          </MDTypography>
        </MDBox>
      </Card>
    </ExternalLayout>
  );
}

export default TermsAndConditions;
